/**
 * Harness wire DTO 到前端领域模型的共享映射层。
 * 流式事件和 Run 查询共用这里的映射，避免两条路径产生不同的字段语义。
 */
import { asNonEmptyString, isPlainObject } from './client'
import type { HarnessPendingToolCall, HarnessRunView } from './types'

export function parseHarnessRunView(
  data: unknown,
  fallbackConversationId: string,
  fallbackRunId: string
): HarnessRunView {
  const run = data as {
    conversation_id?: unknown
    run_id?: unknown
    status?: unknown
    pending_tool_calls?: unknown
    final_reply?: unknown
    usage?: unknown
    error?: unknown
    last_event_seq?: unknown
    state_version?: unknown
  }
  const conversationId =
    asNonEmptyString(run?.conversation_id) || fallbackConversationId
  const runId = asNonEmptyString(run?.run_id) || fallbackRunId
  const status = asNonEmptyString(run?.status)
  if (!conversationId || !runId || !status) {
    throw new Error('Agent 服务返回了无效运行状态')
  }

  const view: HarnessRunView = {
    conversationId,
    runId,
    status,
    pendingToolCalls: Array.isArray(run?.pending_tool_calls)
      ? run.pending_tool_calls.map(parseHarnessPendingToolCall)
      : [],
    finalReply: typeof run?.final_reply === 'string' ? run.final_reply : null,
  }
  if (run?.usage !== undefined) {
    view.usage = isPlainObject(run.usage) ? run.usage : null
  }
  if (run?.error !== undefined) {
    view.error = isPlainObject(run.error) ? run.error : null
  }
  if (typeof run?.last_event_seq === 'number') {
    view.lastEventSeq = run.last_event_seq
  }
  if (typeof run?.state_version === 'number') {
    view.stateVersion = run.state_version
  }
  return view
}

function parseHarnessPendingToolCall(value: unknown): HarnessPendingToolCall {
  const call = value as {
    tool_call_id?: unknown
    kind?: unknown
    name?: unknown
    arguments?: unknown
    batch_id?: unknown
    requires_confirmation?: unknown
    parameter_fingerprint?: unknown
  }
  return {
    toolCallId: asNonEmptyString(call?.tool_call_id),
    kind: asNonEmptyString(call?.kind),
    name: asNonEmptyString(call?.name),
    arguments: isPlainObject(call?.arguments) ? call.arguments : {},
    batchId: asNonEmptyString(call?.batch_id) || null,
    requiresConfirmation: call?.requires_confirmation === true,
    parameterFingerprint: asNonEmptyString(call?.parameter_fingerprint) || null,
  }
}
